import { getHighlightedExcerpts } from "./_getHighlightedExcerpts";

interface ProcessDocumentTextProps {
  htmlText: string;
  hideRevoked?: boolean;
}

export const processDocumentText = ({
  htmlText,
  hideRevoked = false,
}: ProcessDocumentTextProps) => {
  if (!htmlText) return htmlText;

  if (htmlText.includes("autor-grupo")) {
    return htmlText;
  }

  let processedText = htmlText;

  // OCULTAR REVOGADOS
  if (hideRevoked) {
    processedText = processedText.replace(
      /<p[^>]*class=["']?(Revogado|revogado)["']?[^>]*>[\s\S]*?<\/p>/gi,
      "",
    );
  }

  // TÍTULO
  processedText = processedText.replace(
    /<p\s+class=["']?Titulo["']?\s*>(.*?)<\/p>/gis,
    '<h1 class="Titulo">$1</h1>',
  );

  // REMOVER onclick
  processedText = processedText.replace(
    /\s+onClick\s*=\s*["'][^"']*["']/gi,
    "",
  );

  // REMOVER role="button" das notas
  processedText = processedText.replace(
    /(<span[^>]*class=["']?nota["']?[^>]*)\s+role=["']button["']([^>]*>)/gi,
    "$1$2",
  );

  // AGRUPAR Autor + Tabela
  const autorTabelaPattern =
    /(<p[^>]*class=["']?Autor["']?[^>]*>.*?<\/p>)\s*(<p[^>]*class=["']?Tabela["']?[^>]*>.*?<\/p>)/gis;

  processedText = processedText.replace(
    autorTabelaPattern,
    '<div class="autor-grupo">$1$2</div>',
  );

  // AGRUPAR Autor + AutorDescricao
  const autorDescricaoPattern =
    /(<p[^>]*class=["']?Autor["']?[^>]*>.*?<\/p>)\s*(<p[^>]*class=["']?AutorDescricao["']?[^>]*>.*?<\/p>)/gis;
  const autorDescricaoMatches = [
    ...processedText.matchAll(autorDescricaoPattern),
  ];

  if (autorDescricaoMatches.length > 0)
    processedText = processedText.replace(
      autorDescricaoPattern,
      '<div class="autor-grupo">$1$2</div>',
    );

  const parser = new DOMParser();
  const doc = parser.parseFromString(processedText, "text/html");

  const buttonPatterns = [
    /^Regulamentação/i,
    /^Modificação/i,
    /^Alteração/i,
    /^Redação/i,
    /^Norma\(s\) Correlata\(s\)$/i,
    /^Mensagem de Veto$/i,
    /^Histórico de Alterações$/i,
    /^(ADI|ADC|ADO|ADPF)\s*(?:n[º°]?\s*)?.+$/i,
  ];

  doc.querySelectorAll("p.RedacaoDada a").forEach((link) => {
    const text = link.textContent?.replace(/\s+/g, " ").trim() ?? "";

    if (buttonPatterns.some((pattern) => pattern.test(text))) {
      link.classList.add("buttonLinks");
    }
  });

  const paragraphs = Array.from(doc.querySelectorAll("p.RedacaoDada"));

  let i = 0;

  while (i < paragraphs.length) {
    const current = paragraphs[i];

    if (!current?.querySelector("a")) {
      i++;
      continue;
    }

    const group = [current];
    let next = current.nextElementSibling;

    while (
      next &&
      next.tagName === "P" &&
      next.className.includes("RedacaoDada") &&
      next.querySelector("a")
    ) {
      group.push(next);
      next = next.nextElementSibling;
    }

    if (group.length > 1) {
      const wrapper = doc.createElement("div");
      wrapper.className = "redacao-links";

      current.parentNode?.insertBefore(wrapper, current);

      group.forEach((el) => wrapper.appendChild(el));
    }

    i += group.length;
  }

  processedText = doc.body.innerHTML;

  return processedText;
};

export const parseChapter = (rawHtml: string, query?: string) => {
  if (!rawHtml) return { titulo: "", notas: "" };
  let html = processDocumentText({ htmlText: rawHtml });

  const notaRegex = /<p[^>]*class=["']?Nota["']?[^>]*>[\s\S]*?<\/p>/gi;
  const notas = html?.match(notaRegex) || [];

  const tituloHtml = html.replace(notaRegex, "").trim();

  const notasHighlighted = notas.map((n) =>
    query ? getHighlightedExcerpts(n, query, n.length) : n,
  );

  return {
    title: tituloHtml,
    notes: notasHighlighted.join(""),
  };
};
